<template>
	<footer
		:style="[$_appViewPosition_positionBottom]"
	>

		<div
			class="footer flex-vcenter"
			v-if="$mq.isDesktop()"
		>
			
			<div
				class="tot-price"
				v-if="order"
			>
				<div
					v-if="orderHasDiscount"
					class="new-price"
				>
					{{ order.prices.net | priceFilter }}
				</div>

				<div
					:class="{ 'old-price': orderHasDiscount }"
				>
					<span
						v-if="orderHasDiscount"
						v-html="`invece di `"
					/>
					<span
						:class="{ 'strike': orderHasDiscount }"
						v-if="order.prices"
					>
						{{ order.prices.gross | priceFilter }}
					</span>
				</div>
			</div>

			<div
				v-if="order"
			>
				<div>
					Ricette: {{ order.prices.plan | priceFilter }} <span v-if="order.recipes.length >= 1">(<b>{{ order.getPlanPricePerPortion() | priceFilter }}</b> a porzione) </span>
						<info-tooltip
							style='font-size: 14px'
							:src="`Aggiungi ricette e ottieni il <b>miglior prezzo a porzione!</b>`"
							direction='top'
						/>
				</div>
				<div v-if="!!order.prices.recipes">
					Premium: {{ order.prices.recipes | priceFilter }}
				</div>
				<div
					v-if="order.extras.length > 0"
				>
					Altri prodotti: {{ order.prices.extras | priceFilter }}
				</div>
				<div
					v-if="orderHasDiscount"
				>
					Sconto: -{{ order.prices.discount | priceFilter }}
				</div>

				<div
					v-if="order.prices.delivery > 0"
					v-html="`Consegna: ${ deliveryPrice }`"
				/>

				<div v-else>
					Consegna: <span class="delivery-free">GRATUITA</span>
				</div>
			</div>

			<div
				class="flex-right flex-vcenter flex"		
			>
				<billing-cart class="mt-1 mr-7" v-if="$mq.isDesktop()"/>

				<CTA
					isWithLoader
					:loading="loading"
					:disabled="disabled"
					@click="confirm()"
					:content="`${confirmLabel} <i class='fas fa-angle-right' />`"
				/>
 			</div>
		</div>
	</footer>
</template>

<script type = "text/javascript">

import InfoTooltip from '../Parts/InfoTooltip'
import BillingCart from '../Checkout/BillingCart'

export default {
	components: {
		InfoTooltip,
		BillingCart
	},
	props: {
		order: {
			type: Object,
			default () {
				return null
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		error: {
			type: String,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		actionExecuted: {
			type: Boolean,
			default: false
		},
		billIsActive: {
			type: Boolean,
			default: false
		},
		isConfirmed: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		orderHasDiscount () {
			return this.order && this.order.discount && this.order.discount.amount && this.order.discount.amount != 0
		},

		confirmLabel () {
			if (this.actionExecuted) return 'Conferma'

			if (this.$route.params.referr === 'topSku') return 'Vai al riepilogo'

			return 'Conferma'
		},

		deliveryPrice () {
			if (!this.order) return

			if (this.order.prices.delivery > 0) {
				return '€ ' + this.order.prices.delivery.replace('.', ',')
			}
			return 'gratuita'
		}
	},

	methods: {
		confirm () {
			if (this.disabled) {
				return false;
			}

			this.$emit('confirm')
		}
	}
}
</script>

<style scoped>

footer >>> .loading {
	transform: translate(-50%, -50%) scale(0.7);
}

footer {
	position: fixed;
	z-index: 3;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #ffffff;
	box-shadow: 0 -1px 20px rgba(0, 0, 0, 0.12);
	-webkit-transition: -webkit-transform .3s;
	transition: -webkit-transform .3s;
	transition: transform .3s;
	transition: transform .3s, -webkit-transform .3s;
	transition: opacity .3s ease-out;
	font-size: 14px;
    line-height: 1.3;
    min-height: 60px;
}

footer .fa-angle-right {
	font-size: 16px;
	padding-left: 5px;
	padding-top: 2px;
}

.btn-green {
	position: relative;
	min-width: 165px;
}

.footer {
	padding: 0.3em 2em;
}

.tot-price {
	margin-right: 15px;
	font-size: 38px;
	font-weight: bold;
}

.new-price {
	font-size: 35px;
	color: red;
	line-height: 1.2;
}

.old-price {
	font-size: 15px;
	font-weight: normal;
}

@media (max-width: 1024px) {
	.footer-bill {
		padding:10px;
	}
}
.footer-bill >>> button {
	background-color: var(--quomi-primary);
	color: white;
	padding: 10px 10px;
	margin: 0;
}

.footer-bill .btn-big {
	padding: 10px;
	flex-basis: 100%;
	height: 45px;
}

.delivery-free {
	font-weight: bold;
	color: var(--quomi-primary);
}

</style>
